export const notificationConstants = {
    NOTIFICATION_RECEIVED: 'NOTIFICATION_RECEIVED',
}

export default notificationConstants;
